import gql from 'graphql-tag';

export default gql`
    query CountLoadsByJobWellhead($input: CountLoadsByJobWellheadInput) {
        countLoadsByJobWellhead(input: $input) {
            count
        }
    }
`;
